import React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTheme, alpha } from '@mui/material/styles';

const DashboardPage: React.FC = () => {
  const theme = useTheme();

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh' }}>
      <Card
        elevation={0}
        sx={{
          maxWidth: 500,
          textAlign: 'center',
          borderRadius: 3,
          bgcolor: alpha(theme.palette.primary.main, 0.04),
          border: `1px solid ${alpha(theme.palette.primary.main, 0.1)}`,
        }}
      >
        <CardContent sx={{ p: 5 }}>
          <Box
            component="img"
            src="/logo.svg"
            alt="TrueOne"
            sx={{ height: 48, mb: 3 }}
            onError={(e: any) => { e.target.style.display = 'none'; }}
          />
          <Typography variant="h4" fontWeight={600} sx={{ mb: 1 }}>
            Welcome to TrueOne
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Machine inspection and maintenance management platform.
          </Typography>
        </CardContent>
      </Card>
    </Box>
  );
};

export default DashboardPage;
